var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "front-page-searcher",
    attrs: {
      "id": "HomeSearchEmployee"
    }
  }, [_c('section', {
    staticClass: "search-home",
    class: {
      'open block--dark': _vm.searchActive
    }
  }, [_c('div', {
    staticClass: "search-inputs",
    on: {
      "click": _vm.OpenSearch
    }
  }, [_c('div', {
    staticClass: "loupe"
  }, [(!_vm.searchActive) ? _c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Forside",
      "transform": "translate(-129.000000, -591.000000)",
      "stroke": "#343638",
      "stroke-width": "2"
    }
  }, [_c('g', {
    attrs: {
      "id": "Filter-employee",
      "transform": "translate(100.000000, 570.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Search",
      "transform": "translate(30.000000, 19.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Icon:-Search",
      "transform": "translate(0.000000, 3.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.5,13.5 L19.5,19.5",
      "id": "Line",
      "fill": "#343638",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "7.5",
      "cy": "7.5",
      "r": "7.5"
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.searchActive) ? _c('svg', {
    attrs: {
      "width": "22px",
      "height": "22px",
      "viewBox": "0 0 22 22",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "Forside-med-søk",
      "transform": "translate(-129.000000, -591.000000)",
      "stroke-width": "2",
      "stroke": "#FFFFFF"
    }
  }, [_c('g', {
    attrs: {
      "id": "Filter-employee",
      "transform": "translate(100.000000, 570.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Search",
      "transform": "translate(30.000000, 19.000000)"
    }
  }, [_c('g', {
    attrs: {
      "id": "Icon:-Search"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(0.000000, 3.000000)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.5,13.5 L19.5,19.5",
      "id": "Line",
      "fill": "#343638",
      "stroke-linecap": "square"
    }
  }), _vm._v(" "), _c('circle', {
    attrs: {
      "id": "Oval",
      "cx": "7.5",
      "cy": "7.5",
      "r": "7.5"
    }
  })])])])])])])]) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "search-input",
    attrs: {
      "placeholder": _vm.inputPlaceholder
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "focus": _vm.onInputFocus,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.role) ? _c('catdropdown', {
    attrs: {
      "dataList": _vm.role,
      "selection": _vm.currentRole
    },
    on: {
      "update:selection": function($event) {
        _vm.currentRole = $event
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.categoried) ? _c('catdropdown', {
    attrs: {
      "dataList": _vm.categoried,
      "selection": _vm.currentCategory
    },
    on: {
      "update:selection": function($event) {
        _vm.currentCategory = $event
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.searchActive) ? _c('div', {
    staticClass: "search-container",
    class: {
      'no-results': _vm.filteredList.length == 0
    }
  }, [(_vm.userErrorInfo) ? _c('div', {
    staticClass: "message message--info"
  }, [_vm._v(_vm._s(_vm.userErrorInfo))]) : _vm._e(), _vm._v(" "), ((!_vm.filteredList[0] && (_vm.searchName /*|| currentCategory*/ ))) ? _c('div', {
    staticClass: "message message--info"
  }, [_vm._v(_vm._s(_vm.no_found_text))]) : _vm._e(), _vm._v(" "), ((_vm.filteredList[0])) ? _c('ul', {
    staticClass: "page-employees-rel clearfix"
  }, _vm._l((_vm.filteredList), function(employee, key) {
    return _c('li', {
      key: employee.id,
      staticClass: "equal-boy"
    }, [_c('singleemployee', {
      attrs: {
        "postdata": employee
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), (_vm.loadingPosts) ? _c('preloader', {
    staticClass: "posts-preload"
  }) : _vm._e()], 1) : _vm._e()])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26ce8fbe","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue/HomeSearchEmployee.vue
// module id = 242
// module chunks = 0